import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../firebase";

const Blog = () => {
  const [blogPosts, setBlogPosts] = useState([]);

  // Fetch blogs from Firestore
  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const blogsRef = collection(db, "blogs");
        const q = query(blogsRef, orderBy("date", "desc"));
        const snapshot = await getDocs(q);

        const blogs = snapshot.docs.map(doc => {
          const data = doc.data();
          return {
            id: doc.id,
            title: data.title,
            excerpt: data.excerpt,
            slug: data.slug,
            image: data.image,
            date: data.date?.toDate().toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            }),
          };
        });

        setBlogPosts(blogs);
      } catch (err) {
        console.error("Error fetching blogs:", err);
      }
    };

    fetchBlogs();
  }, []);

  // Scroll-reveal animation
  useEffect(() => {
    const elements = document.querySelectorAll(".scroll-reveal");
    const reveal = () => {
      elements.forEach(el => {
        const top = el.getBoundingClientRect().top;
        if (top < window.innerHeight - 80) {
          el.classList.add("revealed");
        }
      });
    };
    window.addEventListener("scroll", reveal);
    reveal();
    return () => window.removeEventListener("scroll", reveal);
  }, [blogPosts]);

  return (
    <div className="min-h-screen pt-24 pb-16 px-4 md:px-20" style={{ backgroundColor: "var(--bg-1)", color: "var(--brand-dark)" }}>
      <div className="container-custom">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-brand-dark mb-6 text-center scroll-reveal">
          DVV Real Estate Blog
        </h1>
        <p className="text-lg text-center text-gray-600 mb-14 max-w-3xl mx-auto scroll-reveal">
          Expert insights on VMRDA approvals, real estate investments, and property trends in Visakhapatnam.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
  {blogPosts.map(post => (
    <div
      key={post.id}
      className="bg-white rounded-2xl shadow-md hover:shadow-xl transition overflow-hidden scroll-reveal animate-fade-up"
    >
      <img src={post.image} alt={post.title} className="w-full h-56 object-cover" />
      <div className="p-6">
        <p className="text-sm text-gray-500 mb-2">{post.date}</p>
        <h3 className="text-xl font-semibold mb-3">{post.title}</h3>
        <p className="text-gray-600 mb-5 leading-relaxed">{post.excerpt}</p>
        <Link to={`/blog/${post.slug}`} className="text-brand-gold font-semibold hover:underline">
          Read More →
        </Link>
      </div>
    </div>
  ))}
</div>


        {/* CTA Section */}
        <section className="mt-20 rounded-3xl bg-gradient-to-r from-[var(--bg-3)] to-white p-10 md:p-16 text-center scroll-reveal animate-fade-up">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Ready to Invest in Your Dream Property?
          </h2>
          <p className="text-lg text-gray-700 mb-8 max-w-2xl mx-auto">
            Explore VMRDA & RERA approved projects with complete legal clarity.
          </p>
          <Link
            to="/contact"
            className="inline-block bg-brand-dark text-white px-8 py-3 rounded-xl font-semibold hover:bg-brand-dark/90 transition"
          >
            Contact Us
          </Link>
        </section>
      </div>

      {/* Tailwind CSS animation */}
      <style>
        {`
          .scroll-reveal {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.7s ease-out;
          }
          .scroll-reveal.revealed {
            opacity: 1;
            transform: translateY(0);
          }
          .animate-fade-up {
            will-change: transform, opacity;
          }
        `}
      </style>
    </div>
  );
};

export default Blog;